var map = {
	"./Cricket.gif": 1076,
	"./Jarvis.gif": 5495,
	"./Laundry.gif": 2837,
	"./Overlay/MidOverlay": 579,
	"./Overlay/MidOverlay.jsx": 579,
	"./Overlay/OverlayCard": 1154,
	"./Overlay/OverlayCard.jsx": 1154,
	"./Production.gif": 1520,
	"./Projects": 8138,
	"./Projects.css": 266,
	"./Projects.jsx": 8138,
	"./Quiz.gif": 2746,
	"./Voice.gif": 8813,
	"./card.gif": 6102,
	"./projectsData": 4988,
	"./projectsData.json": 4988
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 648;